import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import Sidebar from "../Layouts/Sidebar";
import Topbar from "./Topbar";
import Loader from "../Components/UI/Loader";

const Master = () => {
  const isLoading = useSelector((state) => state.ui?.isLoading);

  return (
    <>
      <Topbar />
      <Sidebar />
      <section className="main-content">
        <div className="card_table">
          <Outlet />
        </div>
      </section>
      {isLoading && <Loader />}
    </>
  );
};

export default Master;
